import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState = {
  getOrderData: {},
  getOrderLoading: false,
  getOrderError: null as SerializedError | null,
};

interface IGetOrder {
  accessToken: string;
  orderId: string;
}

export const getOrderFunc = createAsyncThunk('getOrder/getOrderFunc', async (values: IGetOrder) => {
  const data1 = JSON.stringify({
    query: `query getOrder($orderId: ID!) {
  order(orderId: $orderId) {
    payment {
      paymentStatus
    }
    _id
  }
}
`,
    variables: {
      orderId: values.orderId,
    },
  });

  const config = initialConfig(
    'https://api.hophop.com.tr/payment/graphql',
    data1,
    values.accessToken
  );

  const response = axios(config)
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => err);

  const data = await response;
  return data;
});

const getOrder = createSlice({
  name: 'getOrder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOrderFunc.pending, (state) => {
      state.getOrderLoading = true;
    });
    builder.addCase(getOrderFunc.fulfilled, (state, action) => {
      state.getOrderLoading = false;
      state.getOrderData = action.payload?.data?.order?.payment;
      state.getOrderError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(getOrderFunc.rejected, (state, action) => {
      state.getOrderLoading = false;
      state.getOrderError = action.error;
    });
  },
});

export default getOrder.reducer;
